import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo/logo.svg';
import { HashLink } from 'react-router-hash-link';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <nav className="navbar bg-primary sticky top-0 z-10 flex justify-between px-4 lg:px-60 md:px-32">
            {/* ====================website logo==================== */}
            <Link to="/" className="btn btn-ghost">
                <img width={110} src={logo} alt="" />
            </Link>
            {/* ====================website menu==================== */}
            <div>
                {/* ====================desktop menu==================== */}
                <ul className="lg:flex items-center justify-between hidden">
                    <li className="rounded-box hover:text-accent mr-12">
                        <HashLink smooth to="home#home">
                            Home
                        </HashLink>
                    </li>
                    <li className="rounded-box hover:text-accent mr-12">
                        <Link to="about">About</Link>
                    </li>
                    <li className="rounded-box hover:text-accent mr-12">
                        <HashLink smooth to="home#skills">
                            Skills
                        </HashLink>
                    </li>
                    <li className="rounded-box hover:text-accent mr-12">
                        <HashLink smooth to="home#experience">
                            Experience
                        </HashLink>
                    </li>
                    <li className="rounded-box hover:text-accent mr-12">
                        <HashLink smooth to="home#portfolio">
                            Portfolio
                        </HashLink>
                    </li>
                    <li className="rounded-box hover:text-accent">
                        <HashLink smooth to="home#contact">
                            Contact
                        </HashLink>
                    </li>
                </ul>
                {/* ====================mobile & tab menu==================== */}
                <div className="dropdown">
                    <label
                        tabIndex={0}
                        className="btn btn-ghost btn-circle flex lg:hidden"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        {!isOpen && (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M4 6h16M4 12h16M4 18h7"
                                />
                            </svg>
                        )}
                        {isOpen && (
                            <svg
                                className="block h-6 w-6"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                aria-hidden="true"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        )}
                    </label>
                    {isOpen && (
                        <ul
                            tabIndex={0}
                            className="menu menu-compact bg-primary w-52 md:w-72 absolute mt-4 rounded-box shadow-2xl p-3 text-center"
                            style={{ marginLeft: '-160px' }}
                        >
                            <li
                                className="rounded-box hover:bg-accent"
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                <HashLink smooth to="home#home">
                                    Home
                                </HashLink>
                            </li>
                            <li
                                className="rounded-box hover:bg-accent"
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                <Link to="about">About</Link>
                            </li>
                            <li
                                className="rounded-box hover:bg-accent"
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                <HashLink smooth to="home#skills">
                                    Skills
                                </HashLink>
                            </li>
                            <li
                                className="rounded-box hover:bg-accent"
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                <HashLink smooth to="home#experience">
                                    Experience
                                </HashLink>
                            </li>
                            <li
                                className="rounded-box hover:bg-accent"
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                <HashLink smooth to="home#portfolio">
                                    Portfolio
                                </HashLink>
                            </li>
                            <li
                                className="rounded-box hover:bg-accent"
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                <HashLink smooth to="home#contact">
                                    Contact
                                </HashLink>
                            </li>
                        </ul>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
